import api from '../../services/api';

let inFlightRequest = null

async function fetchNavigationSections() {
  try {
    return await api.get('/screens/_navigation')
  } catch (error) {
    if (error.response) {
      throw error
    }
    return api.get('/screens/_navigation')
  }
}

export default {
  state: {
    sections: [],
    fetched: false
  },
  getters: {
    dynamicMenuGroups(state) {
      return state.sections
        .map((section) => ({
          name: section.label || "",
          itens: (section.items || []).map((item) => ({
            icon: item.icon || "mdi-view-dashboard",
            text: item.label,
            execute: `/screens/${item.view}`
          }))
        }))
        .filter((group) => group.itens.length)
    },
    paramsForView: (state) => (view) => {
      for (const section of state.sections) {
        const item = (section.items || []).find((candidate) => candidate.view === view)
        if (item) {
          return item.params || []
        }
      }
      return []
    }
  },
  mutations: {
    setDynamicNavigationSections(state, payload) {
      state.sections = payload
    },
    setDynamicNavigationFetched(state, payload) {
      state.fetched = payload
    }
  },
  actions: {
    apiGetNavigationSections({ commit }) {
      if (inFlightRequest) {
        return inFlightRequest
      }
      inFlightRequest = (async () => {
        try {
          const data = await fetchNavigationSections()
          commit("setDynamicNavigationSections", data.data.sections || [])
          commit("setDynamicNavigationFetched", true)
        } catch (error) {
          if (error.response && error.response.status === 404) {
            commit("setDynamicNavigationSections", [])
            commit("setDynamicNavigationFetched", true)
            return
          }
          throw error
        } finally {
          inFlightRequest = null
        }
      })()
      return inFlightRequest
    }
  }
}
